import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import "./TryCode.css"; 
const TryCode = () => {
  const [isActive, setIsActive] = useState(true);

  const toggleSidebar = () => {
    setIsActive(!isActive);
    const sidebar = document.getElementById('sidebar');
    sidebar.classList.toggle('active-nav');
  };

  return (
    <>
     <div className={`side-navbar ${isActive ? 'active-nav' : ''} d-flex justify-content-between flex-wrap flex-column`} id="sidebar">
      <ul className="nav flex-column text-white w-100">
        <NavLink className="nav-link h3 text-white my-2">
          Ram Hospital
        </NavLink>
        <li className="nav-link">
        <NavLink className="nav-link navlinks" to="/dashboard">
          <i className="fa fa-home"></i>
          <span className="mx-2">Dashboard</span>
          </NavLink>
          </li>
          <li>
          <NavLink className="nav-link navlinks" to="appointments">
          <i className="fa fa-edit"></i>
          <span className="mx-2">Appointments</span>
          </NavLink>
        </li>
        <li className="nav-link">
          <NavLink className="nav-link navlinks" to="/dashboard/patients">
          <i className="fa fa-book"></i>
          <span className="mx-2">Patients</span>
          </NavLink>
        </li>
        <li className="nav-link">
          <NavLink className="nav-link navlinks" to="/dashboard/users">
          <i className="fa fa-group"></i>
          <span className="mx-2">Staff</span>
          </NavLink>
        </li>
        <li className="nav-link">
          <NavLink className="nav-link navlinks" to="/dashboard/medicines">
          <i className="fa fa-medkit"></i>
          <span className="mx-2">Medicines</span>
          </NavLink>
        </li>
      </ul>
      </div>
      <div className={`p-1 my-container ${isActive ? 'active-cont' : ''}`}>
        <nav className="navbar top-navbar navbar-light bg-light px-5">
          <button className="btn border-0" id="menu-btn" onClick={toggleSidebar}>
          <span className="fa fa-bars"></span>
          </button>
        </nav>
        <h3 className="text-dark p-3">RESPONSIVE SIDEBAR NAV 💻 📱</h3>
        <p className="px-3">Responsive navigation sidebar built using <a className="text-dark" href="https://getbootstrap.com/">Bootstrap 5</a>.</p>
        <p className="px-3"><a href="https://github.com/harshitjain-hj" className="text-dark">Checkout my Github</a></p>
      </div>
      </>
  );
};

export default TryCode;
